<template>
  <Grid>
    <template v-if="hasCashlessPay || editCashlessPay">
      <Col6>
        <Type />
      </Col6>

      <!-- Due to vshow nature -->
      <div class="col-12" v-show="isFreedomPay">
        <FreedomPay />
      </div>

      <Col12>
        <Tenders :isDisabled="!editCashlessPay" :mealPlanType="cashlessPayType" />
      </Col12>
    </template>

    <template v-else-if="!editCashlessPay">
      <Col12>
        {{ translate(`${LOCALE_PREFIX}.empty`) }}
      </Col12>
    </template>
  </Grid>
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { useFieldValue } from 'vee-validate';
import { useCashlessPay } from '../composables';
import { computed } from 'vue';
import FreedomPay from './freedom-pay/FreedomPay.vue';
import { storeToRefs } from 'pinia';
import Type from '../fields/type/Type.vue';
import { SitesLocalePrefix } from '../../../../../enums';
import { useFinancialConfigStore } from '../../../../../routes';
import { FREEDOM_PAY_TYPES } from '../../enums';
import Tenders from './../../tenders/Tenders.vue';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_CASHLESS_PAYMENT;

// Set cashless pay composable
const { hasCashlessPay } = useCashlessPay();

// Set financial conmfig store
const fConfigStore = useFinancialConfigStore();
const { editCashlessPay } = storeToRefs(fConfigStore);

// Set cashless pay type field value
const cashlessPayType = useFieldValue<string>('type');

// Check if cashless pay type is FreedomPay
const isFreedomPay = computed<boolean>(() => FREEDOM_PAY_TYPES.includes(cashlessPayType.value));
</script>
